module.exports = __webpack_public_path__ + "img/lyfw.1a6ef37.png";